module.exports = __webpack_public_path__ + "static/img/bimfusion.a5864bd4.png";